import React from 'react'
import { makeStyles, TableCell } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import PatientActionsMenu from '../../../Patients/PatientsList/PatientActionsMenu'

const useStyles = ({ highlighted, rowIndex }) =>
  makeStyles({
    root: {
      height: '78px',
      borderTop: rowIndex === 0 && highlighted ? '1px solid' : 0,
      borderRight: highlighted ? '1px solid var(--border-color-1)' : '1px solid var(--border-color-11)',
      borderColor: highlighted ? 'var(--border-color-1)' : 'var(--border-color-11)'
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })({ highlighted, rowIndex })

const OptionsCell = ({ rowIndex, actionRequired = false, patient }) => {
  const classes = useStyles({ highlighted: actionRequired, rowIndex })
  return (
    <TableCell align="center" classes={{ root: classes.root }}>
      <div className={classes.content}>
        <PatientActionsMenu iconComponent={<MoreVert />} patient={patient} user={patient} />
      </div>
    </TableCell>
  )
}

export default React.memo(OptionsCell)
